/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { ProductAttachmentSnapshotFragmentDoc, AttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ProductPreferencesPage_CurrentProductTypeSystemQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductPreferencesPage_CurrentProductTypeSystemQuery = { pimCurrentProductTypeSystem: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimCurrentProductTypeSystemResult', productTypeSystemKey?: Types.PimProductTypeSystemKey | null } };

export type ProductPreferencesPage_ProductTypeFragment = { __typename: 'PimProductType', id: string, key: string, productTypeSystemKey: Types.PimProductTypeSystemKey, label: string };

export type ProductPreferencesPage_ProductTypesQueryVariables = Types.Exact<{
  productTypeKeys: Array<Types.Scalars['String']['input']>;
  productTypeSystemKey?: Types.InputMaybe<Types.PimProductTypeSystemKey>;
  limit: Types.Scalars['Int']['input'];
}>;


export type ProductPreferencesPage_ProductTypesQuery = { pimSearchProductTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchProductTypesResult', productTypes: Array<{ __typename: 'PimProductType', id: string, key: string, productTypeSystemKey: Types.PimProductTypeSystemKey, label: string }> } };

export type ProductPreferencesPage_TemplateProductTypesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ProductPreferencesPage_TemplateProductTypesQuery = { templateProductPlaceholderProductTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'TemplateProductPlaceholderProductTypesResult', productTypes: Array<{ __typename: 'TemplateProductPlaceholderProductType', placeholderCount: number, productType: { __typename: 'PimProductType', id: string, key: string, productTypeSystemKey: Types.PimProductTypeSystemKey, label: string } }> } };

export type ProductPreferencesPage_SearchProductTypesQueryVariables = Types.Exact<{
  searchTerm?: Types.InputMaybe<Types.Scalars['String']['input']>;
  limit: Types.Scalars['Int']['input'];
}>;


export type ProductPreferencesPage_SearchProductTypesQuery = { pimSearchProductTypes: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimSearchProductTypesResult', totalCount: number, productTypes: Array<{ __typename: 'PimProductType', id: string, key: string, productTypeSystemKey: Types.PimProductTypeSystemKey, label: string }> } };

export type ProductPreferencesPage_PreferredProductFields_PimCustomSupplierProduct_Fragment = { __typename: 'PimCustomSupplierProduct', id: string, articleNumber: string, gtin?: string | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> };

export type ProductPreferencesPage_PreferredProductFields_PimSupplierProduct_Fragment = { __typename: 'PimSupplierProduct', id: string, articleNumber: string, gtin?: string | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> };

export type ProductPreferencesPage_PreferredProductFieldsFragment = ProductPreferencesPage_PreferredProductFields_PimCustomSupplierProduct_Fragment | ProductPreferencesPage_PreferredProductFields_PimSupplierProduct_Fragment;

export type ProductPreferencesPage_PreferredProductSupplierFieldsFragment = { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null };

export type ProductPreferencesPage_PreferredProductQueryVariables = Types.Exact<{
  supplierId: Types.Scalars['ID']['input'];
  articleNumber: Types.Scalars['String']['input'];
}>;


export type ProductPreferencesPage_PreferredProductQuery = { pimGetProduct: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'PimGetProductResult', product?: { __typename: 'PimCustomSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, organisationFavourite: boolean, id: string, articleNumber: string, gtin?: string | null, supplier: { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, pricing?: { __typename: 'PimPricing', listPrice?: number | null, purchasePrice?: number | null, netPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue, validFrom: any, validTo?: any | null } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', title: string } } | null, productType?: { __typename: 'PimProductTypeRef', id: string, key: string, label: string, productTypeSystemKey: Types.PimProductTypeSystemKey } | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | { __typename: 'PimSupplierProduct', supplierId: string, manufacturerArticleNumber?: string | null, organisationFavourite: boolean, supplierFavourite: boolean, id: string, articleNumber: string, gtin?: string | null, supplier: { __typename: 'PimSupplier', id: string, title: string, logo?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null }, pricing?: { __typename: 'PimPricing', listPrice?: number | null, purchasePrice?: number | null, netPrice?: number | null } | null, status?: { __typename: 'PimSupplierProductStatus', value: Types.PimSupplierProductStatusValue, validFrom: any, validTo?: any | null } | null, branding?: { __typename: 'PimProductBranding', brand: { __typename: 'PimBrandRef', title: string } } | null, productType?: { __typename: 'PimProductTypeRef', id: string, key: string, label: string, productTypeSystemKey: Types.PimProductTypeSystemKey } | null, texts?: { __typename: 'PimProductTexts', title?: string | null, description?: string | null, extendedDescription?: string | null } | null, attachments: Array<{ __typename: 'ProductAttachmentSnapshot', id: number, title: string, mimeType: string, url: string, group: string }> } | null } };

export const ProductPreferencesPage_ProductTypeFragmentDoc = gql`
    fragment ProductPreferencesPage_ProductType on PimProductType {
  id
  key
  productTypeSystemKey
  label
}
    `;
export const ProductPreferencesPage_PreferredProductFieldsFragmentDoc = gql`
    fragment ProductPreferencesPage_PreferredProductFields on Product {
  id
  articleNumber
  gtin
  texts {
    title
    description
    extendedDescription
  }
  attachments {
    ...ProductAttachmentSnapshot
  }
}
    ${ProductAttachmentSnapshotFragmentDoc}`;
export const ProductPreferencesPage_PreferredProductSupplierFieldsFragmentDoc = gql`
    fragment ProductPreferencesPage_PreferredProductSupplierFields on PimSupplier {
  id
  title
  logo {
    ...AttachmentSnapshot
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export const ProductPreferencesPage_CurrentProductTypeSystemDocument = gql`
    query ProductPreferencesPage_CurrentProductTypeSystem {
  pimCurrentProductTypeSystem {
    ... on PimCurrentProductTypeSystemResult {
      productTypeSystemKey
    }
  }
}
    `;

/**
 * __useProductPreferencesPage_CurrentProductTypeSystemQuery__
 *
 * To run a query within a React component, call `useProductPreferencesPage_CurrentProductTypeSystemQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesPage_CurrentProductTypeSystemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesPage_CurrentProductTypeSystemQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPreferencesPage_CurrentProductTypeSystemQuery(baseOptions?: Apollo.QueryHookOptions<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>(ProductPreferencesPage_CurrentProductTypeSystemDocument, options);
      }
export function useProductPreferencesPage_CurrentProductTypeSystemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>(ProductPreferencesPage_CurrentProductTypeSystemDocument, options);
        }
export function useProductPreferencesPage_CurrentProductTypeSystemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>(ProductPreferencesPage_CurrentProductTypeSystemDocument, options);
        }
export type ProductPreferencesPage_CurrentProductTypeSystemQueryHookResult = ReturnType<typeof useProductPreferencesPage_CurrentProductTypeSystemQuery>;
export type ProductPreferencesPage_CurrentProductTypeSystemLazyQueryHookResult = ReturnType<typeof useProductPreferencesPage_CurrentProductTypeSystemLazyQuery>;
export type ProductPreferencesPage_CurrentProductTypeSystemSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesPage_CurrentProductTypeSystemSuspenseQuery>;
export type ProductPreferencesPage_CurrentProductTypeSystemQueryResult = Apollo.QueryResult<ProductPreferencesPage_CurrentProductTypeSystemQuery, ProductPreferencesPage_CurrentProductTypeSystemQueryVariables>;
export const ProductPreferencesPage_ProductTypesDocument = gql`
    query ProductPreferencesPage_ProductTypes($productTypeKeys: [String!]!, $productTypeSystemKey: PimProductTypeSystemKey, $limit: Int!) {
  pimSearchProductTypes(
    productTypeKeys: $productTypeKeys
    productTypeSystemKey: $productTypeSystemKey
    limit: $limit
  ) {
    ... on PimSearchProductTypesResult {
      productTypes {
        ...ProductPreferencesPage_ProductType
      }
    }
  }
}
    ${ProductPreferencesPage_ProductTypeFragmentDoc}`;

/**
 * __useProductPreferencesPage_ProductTypesQuery__
 *
 * To run a query within a React component, call `useProductPreferencesPage_ProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesPage_ProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesPage_ProductTypesQuery({
 *   variables: {
 *      productTypeKeys: // value for 'productTypeKeys'
 *      productTypeSystemKey: // value for 'productTypeSystemKey'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductPreferencesPage_ProductTypesQuery(baseOptions: Apollo.QueryHookOptions<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables> & ({ variables: ProductPreferencesPage_ProductTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>(ProductPreferencesPage_ProductTypesDocument, options);
      }
export function useProductPreferencesPage_ProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>(ProductPreferencesPage_ProductTypesDocument, options);
        }
export function useProductPreferencesPage_ProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>(ProductPreferencesPage_ProductTypesDocument, options);
        }
export type ProductPreferencesPage_ProductTypesQueryHookResult = ReturnType<typeof useProductPreferencesPage_ProductTypesQuery>;
export type ProductPreferencesPage_ProductTypesLazyQueryHookResult = ReturnType<typeof useProductPreferencesPage_ProductTypesLazyQuery>;
export type ProductPreferencesPage_ProductTypesSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesPage_ProductTypesSuspenseQuery>;
export type ProductPreferencesPage_ProductTypesQueryResult = Apollo.QueryResult<ProductPreferencesPage_ProductTypesQuery, ProductPreferencesPage_ProductTypesQueryVariables>;
export const ProductPreferencesPage_TemplateProductTypesDocument = gql`
    query ProductPreferencesPage_TemplateProductTypes {
  templateProductPlaceholderProductTypes {
    ... on TemplateProductPlaceholderProductTypesResult {
      productTypes {
        placeholderCount
        productType {
          ...ProductPreferencesPage_ProductType
        }
      }
    }
  }
}
    ${ProductPreferencesPage_ProductTypeFragmentDoc}`;

/**
 * __useProductPreferencesPage_TemplateProductTypesQuery__
 *
 * To run a query within a React component, call `useProductPreferencesPage_TemplateProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesPage_TemplateProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesPage_TemplateProductTypesQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductPreferencesPage_TemplateProductTypesQuery(baseOptions?: Apollo.QueryHookOptions<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>(ProductPreferencesPage_TemplateProductTypesDocument, options);
      }
export function useProductPreferencesPage_TemplateProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>(ProductPreferencesPage_TemplateProductTypesDocument, options);
        }
export function useProductPreferencesPage_TemplateProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>(ProductPreferencesPage_TemplateProductTypesDocument, options);
        }
export type ProductPreferencesPage_TemplateProductTypesQueryHookResult = ReturnType<typeof useProductPreferencesPage_TemplateProductTypesQuery>;
export type ProductPreferencesPage_TemplateProductTypesLazyQueryHookResult = ReturnType<typeof useProductPreferencesPage_TemplateProductTypesLazyQuery>;
export type ProductPreferencesPage_TemplateProductTypesSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesPage_TemplateProductTypesSuspenseQuery>;
export type ProductPreferencesPage_TemplateProductTypesQueryResult = Apollo.QueryResult<ProductPreferencesPage_TemplateProductTypesQuery, ProductPreferencesPage_TemplateProductTypesQueryVariables>;
export const ProductPreferencesPage_SearchProductTypesDocument = gql`
    query ProductPreferencesPage_SearchProductTypes($searchTerm: String, $limit: Int!) {
  pimSearchProductTypes(searchTerm: $searchTerm, limit: $limit) {
    ... on PimSearchProductTypesResult {
      totalCount
      productTypes {
        ...ProductPreferencesPage_ProductType
      }
    }
  }
}
    ${ProductPreferencesPage_ProductTypeFragmentDoc}`;

/**
 * __useProductPreferencesPage_SearchProductTypesQuery__
 *
 * To run a query within a React component, call `useProductPreferencesPage_SearchProductTypesQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesPage_SearchProductTypesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesPage_SearchProductTypesQuery({
 *   variables: {
 *      searchTerm: // value for 'searchTerm'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useProductPreferencesPage_SearchProductTypesQuery(baseOptions: Apollo.QueryHookOptions<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables> & ({ variables: ProductPreferencesPage_SearchProductTypesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>(ProductPreferencesPage_SearchProductTypesDocument, options);
      }
export function useProductPreferencesPage_SearchProductTypesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>(ProductPreferencesPage_SearchProductTypesDocument, options);
        }
export function useProductPreferencesPage_SearchProductTypesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>(ProductPreferencesPage_SearchProductTypesDocument, options);
        }
export type ProductPreferencesPage_SearchProductTypesQueryHookResult = ReturnType<typeof useProductPreferencesPage_SearchProductTypesQuery>;
export type ProductPreferencesPage_SearchProductTypesLazyQueryHookResult = ReturnType<typeof useProductPreferencesPage_SearchProductTypesLazyQuery>;
export type ProductPreferencesPage_SearchProductTypesSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesPage_SearchProductTypesSuspenseQuery>;
export type ProductPreferencesPage_SearchProductTypesQueryResult = Apollo.QueryResult<ProductPreferencesPage_SearchProductTypesQuery, ProductPreferencesPage_SearchProductTypesQueryVariables>;
export const ProductPreferencesPage_PreferredProductDocument = gql`
    query ProductPreferencesPage_PreferredProduct($supplierId: ID!, $articleNumber: String!) {
  pimGetProduct(supplierId: $supplierId, articleNumber: $articleNumber) {
    ... on PimGetProductResult {
      product {
        ...ProductPreferencesPage_PreferredProductFields
        ... on PimSupplierProduct {
          supplierId
          manufacturerArticleNumber
          organisationFavourite
          supplierFavourite
          supplier {
            ...ProductPreferencesPage_PreferredProductSupplierFields
          }
          pricing {
            listPrice
            purchasePrice
            netPrice
          }
          status {
            value
            validFrom
            validTo
          }
          branding {
            brand {
              title
            }
          }
          productType {
            id
            key
            label
            productTypeSystemKey
          }
        }
        ... on PimCustomSupplierProduct {
          supplierId
          manufacturerArticleNumber
          organisationFavourite
          supplier {
            ...ProductPreferencesPage_PreferredProductSupplierFields
          }
          pricing {
            listPrice
            purchasePrice
            netPrice
          }
          status {
            value
            validFrom
            validTo
          }
          branding {
            brand {
              title
            }
          }
          productType {
            id
            key
            label
            productTypeSystemKey
          }
        }
      }
    }
  }
}
    ${ProductPreferencesPage_PreferredProductFieldsFragmentDoc}
${ProductPreferencesPage_PreferredProductSupplierFieldsFragmentDoc}`;

/**
 * __useProductPreferencesPage_PreferredProductQuery__
 *
 * To run a query within a React component, call `useProductPreferencesPage_PreferredProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductPreferencesPage_PreferredProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductPreferencesPage_PreferredProductQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      articleNumber: // value for 'articleNumber'
 *   },
 * });
 */
export function useProductPreferencesPage_PreferredProductQuery(baseOptions: Apollo.QueryHookOptions<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables> & ({ variables: ProductPreferencesPage_PreferredProductQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>(ProductPreferencesPage_PreferredProductDocument, options);
      }
export function useProductPreferencesPage_PreferredProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>(ProductPreferencesPage_PreferredProductDocument, options);
        }
export function useProductPreferencesPage_PreferredProductSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>(ProductPreferencesPage_PreferredProductDocument, options);
        }
export type ProductPreferencesPage_PreferredProductQueryHookResult = ReturnType<typeof useProductPreferencesPage_PreferredProductQuery>;
export type ProductPreferencesPage_PreferredProductLazyQueryHookResult = ReturnType<typeof useProductPreferencesPage_PreferredProductLazyQuery>;
export type ProductPreferencesPage_PreferredProductSuspenseQueryHookResult = ReturnType<typeof useProductPreferencesPage_PreferredProductSuspenseQuery>;
export type ProductPreferencesPage_PreferredProductQueryResult = Apollo.QueryResult<ProductPreferencesPage_PreferredProductQuery, ProductPreferencesPage_PreferredProductQueryVariables>;